import React from 'react';
import { TableCell } from '@material-ui/core';
import { ArrowDropDownCircleOutlined } from '@material-ui/icons';
import { numberFormat } from 'pages/analytics/utils/sales';


interface TotalsTableCellsProps {
  totals: {
    current_year_week_revenue: number;
    last_year_week_revenue: number;
    year_over_year_change: number;
    previous_week_revenue: number;
    week_over_week_change: number;
  }
  showIndicators?: boolean;
}

const TotalsTableCells: React.FC<TotalsTableCellsProps> = ({ totals, showIndicators = false }) => {
  return (
    <>
      <TableCell>
        {numberFormat(
          totals.current_year_week_revenue,
          'currency',
          'long',
          3,
          'standard'
        )}
      </TableCell>
      <TableCell>
        {numberFormat(
          totals.last_year_week_revenue,
          'currency',
          'long',
          3,
          'standard'
        )}
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          {numberFormat(
            totals.year_over_year_change / 100,
            'percent',
            'long',
            1,
            'standard'
          )}
          {showIndicators &&
          <>
            <ArrowDropDownCircleOutlined
              style={{
                fontSize: '16px',
                color: totals.year_over_year_change >= 0 ? 'green' : 'red',
                transform: `rotate(${totals.year_over_year_change >= 0 ? '180deg' : '0'})`
              }}
            />
          </>
          }
        </div>
      </TableCell>
      <TableCell>
        {numberFormat(
          totals.previous_week_revenue,
          'currency',
          'long',
          3,
          'standard'
        )}
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          {numberFormat(
            totals.week_over_week_change / 100,
            'percent',
            'long',
            1,
            'standard'
          )}
          {showIndicators &&
          <>
            <ArrowDropDownCircleOutlined
              style={{
                fontSize: '16px',
                color: totals.week_over_week_change >= 0 ? 'green' : 'red',
                transform: `rotate(${totals.week_over_week_change >= 0 ? '180deg' : '0'})`
              }}
            />
          </>
          }
        </div>
      </TableCell>
    </>
  );
};

export default TotalsTableCells;
